import { TSelectIngredient } from 'business/models/CustomModels';
import { IngredientStockDTO } from 'business/models/Models';
import SelectIngredients from 'components/customComponents/Layers/SelectIngredients';
import SelectStocks from 'components/customComponents/Layers/SelectStocks';
import ELayersView, { ELayersDefaultInput } from 'enums/ELayersView';
import React, { useEffect, useState } from 'react';
import EICheckBox, { EISelectBox } from 'components/customComponents/Layers/EICheckBox';
import RMButton from 'components/customComponents/Controls/RMButton';
import {
  GetIngredients,
  getIngIngType,
  getIngredientType,
  getStockConcVendor,
  isNullOrUndefined,
} from 'utils/Global';
import { cloneDeep } from 'lodash';

const DoeIngredients = (props) => {
  const {
    selectedRowData,
    setMatchedIngredients,
    matchedIngredients,
    doePreviewTableData,
    setDoePreviewTableData,
  } = props;

  const [selectedIngredientType, setSelectedIngredientType] = useState(0);
  const [ingredientTypes, setIngredientTypes] = useState([]);
  const [concentration, setConcentration] = useState('0.0');
  const [highPHStock, setHighPHStock] = useState<IngredientStockDTO>(null);
  const [selectedStock, setSelectedStock] = useState<IngredientStockDTO>();
  const stack: string[] = [];

  const [contentView, setContentViewState] = useState<string>('');

  const [selectedIngredient, setSelectedIngredient] = useState<TSelectIngredient>({
    name: 'Select Ingredient',
    id: 0,
  });

  useEffect(() => {
    if (selectedRowData) {
      setContentViewState(ELayersView.SELECTINGREDIENTSVIEW);
    }
  }, [selectedRowData]);

  useEffect(() => {
    if (!isNullOrUndefined(selectedStock)) {
      getIngredientTypes();
      if (concentration === '0.0') {
        setConcentration(
          !isNullOrUndefined(selectedStock.lowConcentration) &&
            selectedStock.lowConcentration.toFixed(3),
        );
      }
    }
  }, [selectedStock]);

  useEffect(() => {
    if (ingredientTypes && ingredientTypes.length > 0) {
      setSelectedIngredientType(ingredientTypes[0]);
    }
  }, [ingredientTypes]);

  function setContentView(val) {
    setContentViewState(val);
    stack.push(val);
  }

  function changeIngredientType(e) {
    setSelectedIngredientType(Number(e.target.value));
  }

  function getIngredientTypes() {
    if (isNullOrUndefined(selectedStock)) {
      return;
    }
    const selectIngIngType = getIngIngType(selectedIngredient.id);
    const ingType = getIngredientType(selectIngIngType.ingredientTypeId);
    if (ingType.isBuffer) {
      const ingType = GetIngredients().ingredientType.filter(
        (ingType) => ingType.id === selectIngIngType.ingredientTypeId,
      );
      setIngredientTypes(
        ingType.map((ingtype) => {
          return { name: ingtype.name, value: ingtype.id };
        }),
      );
    } else {
      const ingingtypes = GetIngredients().ingredientIngredientType.filter(
        (ingingtype) => ingingtype.ingredientId === selectIngIngType.ingredientId,
      );
      const ingType = ingingtypes.map((ingingtype) =>
        GetIngredients().ingredientType.find(
          (ingtype) => ingtype.id === ingingtype.ingredientTypeId,
        ),
      );
      setIngredientTypes(
        ingType.map((ingtype) => {
          return { name: ingtype.name, value: ingtype.id };
        }),
      );
    }
  }

  const applyIngredientButton = () => {
    const selectedIngredientsData = cloneDeep(matchedIngredients);
    const appliedIngredient = {
      selectedIngredient: selectedIngredient,
      selectedStock: selectedStock,
      selectedIngredientType: '',
      selectedHighpHStock: highPHStock,
    };
    if (selectedIngredientsData.length == 0) {
      selectedIngredientsData.push(appliedIngredient);
    } else {
      const matchedIngredient = selectedIngredientsData.find(
        (x) => x.selectedIngredient.id == selectedIngredient.id,
      );
      if (!matchedIngredient) {
        selectedIngredientsData.push(appliedIngredient);
      }
    }

    const selectedRowIndex = doePreviewTableData.findIndex(
      (x) => x.name == selectedRowData.name,
    );
    const tempPreviewData = cloneDeep(doePreviewTableData);
    tempPreviewData[selectedRowIndex].matchedIngredient = appliedIngredient;

    setDoePreviewTableData(tempPreviewData);
    setMatchedIngredients(selectedIngredientsData);
    setContentView('');
  };

  return (
    <div id='commandpanel-importdoe-doeing-wrapper' className="flex flex-col h-[100%] mt-[10px] ml-[10px] border-solid border-l-2 border-[#F5F5F5]">
      <div id='commandpanel-importdoe-doeing-container' className="h-[10%] bg-[#F5F5F5] text-[14px] flex flex-col justify-center">
        <text id='commandpanel-importdoe-doeing-container-heading' className="pl-[10px] font-[600]">Match to Ingredient</text>
      </div>
      <div id='commandpanel-importdoe-doeing-select-container' className="h-[90%] overflow-hidden">
        {contentView == '' && <></>}
        {contentView === ELayersView.SELECTINGREDIENTSVIEW && (
          <SelectIngredients
            id='commandpanel-importdoe-doeing-selectingview-layer'
            setContentView={setContentView}
            setSelectIngredient={setSelectedIngredient}
          />
        )}

        {contentView === ELayersView.SELECTSTOCKSVIEW && (
          <SelectStocks
            id='commandpanel-importdoe-doeing-selectstockview-layer'
            setContentView={setContentView}
            setSelectStock={setSelectedStock}
            selectIngredient={selectedIngredient}
          />
        )}

        {contentView === ELayersView.HIGHPHVIEW && (
          <SelectStocks
            id='commandpanel-importdoe-doeing-highphview-layer'
            setContentView={setContentView}
            setSelectStock={setHighPHStock}
            selectIngredient={selectedIngredient}
            lowPHStocks={selectedStock}
          />
        )}

        {contentView === ELayersView.EDITINGREDIENTSVIEW && (
          <div id='commandpanel-importdoe-doeing-editingview-layer' className="p-2">
            <EICheckBox
              labelText="Name"
              textBoxText={
                selectedIngredient
                  ? selectedIngredient.name
                  : ELayersDefaultInput.SELECTINGREDIENT
              }
              active={!selectedIngredient}
              onClick={() => {
                setContentView(ELayersView.SELECTINGREDIENTSVIEW);
              }}
            />

            <EICheckBox
              labelText={
                getIngredientType(getIngIngType(selectedIngredient?.id)?.ingredientTypeId)
                  ?.isBuffer
                  ? 'Low pH'
                  : 'Stock'
              }
              textBoxText={
                isNullOrUndefined(selectedStock)
                  ? ELayersDefaultInput.SELECTSTOCKS
                  : getStockConcVendor(selectedStock, true)
              }
              active={!selectedStock && selectedIngredient ? true : false}
              onClick={() => {
                if (!isNullOrUndefined(selectedIngredient)) {
                  setContentView(ELayersView.SELECTSTOCKSVIEW);
                }
              }}
            />

            {getIngredientType(getIngIngType(selectedIngredient?.id)?.ingredientTypeId)
              ?.isBuffer ? (
              <EICheckBox
                labelText="High pH"
                textBoxText={
                  isNullOrUndefined(highPHStock)
                    ? ELayersDefaultInput.SELECTSTOCKS
                    : getStockConcVendor(highPHStock, true)
                }
                active={!isNullOrUndefined(highPHStock)}
                onClick={() => {
                  if (!isNullOrUndefined(selectedIngredient)) {
                    setContentView(ELayersView.HIGHPHVIEW);
                  }
                }}
              />
            ) : null}

            <EISelectBox 
              placeholder="Select Ingredient Type"
              labelText="Type"
              selectedValue={selectedIngredientType}
              onChange={changeIngredientType}
              options={ingredientTypes}
              disabled={ingredientTypes.length <= 1}
            />

            <div id='commandpanel-importdoe-doeing-editingredientview-applybtn-container' className="flex w-full justify-end mt-1">
              <RMButton id='commandpanel-importdoe-doeing-editingredientview-applybtn'
                customStyle={{
                  minHeight: '3rem',
                  maxHeight: '3rem',
                  height: '3rem',
                  lineHeight: '1.375rem',
                  width: '5.125rem',
                  borderRadius: '0.375rem 0.5rem 0.5rem 0.375rem',
                  float: 'right',
                  marginTop: '10px',
                }}
                onClick={applyIngredientButton}
                label={'Apply'}
              ></RMButton>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DoeIngredients;
